import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';
import LinkMore from 'components/LinkMore';

const StyledLinkMore = styled(withParallax(styled(LinkMore)`
`))`
  margin: 52px 0 0;

  ${media.medium`
    margin: 39px 0 0 0;
  `}
`;

StyledLinkMore.defaultProps = {
  isLight: true,
};

export default StyledLinkMore;